var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "tabs-bar-wrapper",
      class: _vm.className,
      style: _vm.defaultStyle,
    },
    [
      _c("div", { ref: "tabsBar", staticClass: "tabs-bar" }, [
        _c(
          "ul",
          { ref: "list", staticClass: "tabs-nav" },
          [
            _vm._l(_vm.tabtitles, function (title, index) {
              return _c(
                "li",
                {
                  key: title.id,
                  ref: `li_${title.id}`,
                  refInFor: true,
                  class: [title.id === _vm.activeId ? "active" : ""],
                  on: {
                    click: function ($event) {
                      return _vm.changeTab(title.id, index)
                    },
                  },
                },
                [
                  _c("span", { ref: `name_${title.id}`, refInFor: true }, [
                    _vm._v(_vm._s(title.name)),
                  ]),
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tab-ink-bar-wrapper",
                style: {
                  transform: _vm.inkBarPosition,
                  webkitTransform: _vm.inkBarPosition,
                  width: _vm.inktabWidth,
                },
              },
              [
                _c("span", {
                  staticClass: "tab-ink-bar",
                  style: {
                    width:
                      _vm.defaultStyle.currentSelectedBottomLine ||
                      _vm.inkWidth,
                  },
                }),
              ]
            ),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }